import { useMemo } from 'react';
import { ClbModal } from '@celebration/react/ClbModal/ClbModal';
import IReactivateModalProps from './IReactivateModalProps';

function ReactivateModal({
    opened,
    closeModalCallback,
    confirmModalCallback,
}: Readonly<IReactivateModalProps>) {
    const modalTitle = useMemo(() => {
        return 'Reativar Transportadora?';
    }, []);

    const modalContent = useMemo(() => {
        return 'Transportadora inativada, deseja ativar novamente e sobrescrever os dados?';
    }, []);

    const confirmationButtonText = useMemo(() => {
        return 'Reativar Transportadora';
    }, []);

    return (
        <ClbModal
            title={modalTitle}
            open={opened}
            onClose={closeModalCallback}
            description={modalContent}
            type="default"
            data-testid="carrier-reactivate-confirmation"
            itemsFooter={[
                {
                    key: 'confirm-button',
                    id: 'confirm-button',
                    label: confirmationButtonText,
                    title: confirmationButtonText,
                    'data-testid': 'modal-confirm-button',
                    onClick: () => confirmModalCallback(),
                    role: 'button',
                    size: 'md',
                },
                {
                    key: 'cancel-button',
                    id: 'cancel-button',
                    label: 'Cancelar',
                    title: 'Cancelar',
                    'data-testid': 'modal-cancel-button',
                    onClick: () => closeModalCallback(),
                    role: 'button',
                    size: 'md',
                    styleType: 'secondary',
                },
            ]}
        />
    );
}

export default ReactivateModal;
